// Language detection shared across the app. English is the default at the
// site root; Greek lives under the /el path prefix.
export function detectLang(path) {
  const p = path != null ? path : (typeof window !== "undefined" ? window.location.pathname : "/");
  return p === "/el" || p.startsWith("/el/") ? "el" : "en";
}

export const LANG = detectLang();
export const BASENAME = LANG === "el" ? "/el" : "/";

// Path within the current language (basename-relative), no /el prefix.
export function currentBasePath() {
  if (typeof window === "undefined") return "/";
  let p = window.location.pathname;
  if (p === "/el" || p.startsWith("/el/")) p = p.slice(3) || "/";
  return p || "/";
}

// Full URL to the same page in the other language.
export function otherLangHref() {
  const base = currentBasePath();
  if (LANG === "el") return base;
  return "/el" + (base === "/" ? "" : base);
}
